import { render } from "./AyudaAtencionInterconsulta.vue?vue&type=template&id=4655cb4d&scoped=true"
import script from "./AyudaAtencionInterconsulta.vue?vue&type=script&lang=js"
export * from "./AyudaAtencionInterconsulta.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=4655cb4d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4655cb4d"]])

export default __exports__